import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const gestionPersonasRoutes: Routes = [
  {
    path: "per_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioPersonasComponent,
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_personas",
    loadChildren: () =>
      import("./components/personas/personas.routes").then(
        (m) => m.personasRoutes,
      ),
    data: {
      label: "Personas",
      icon: "person",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_legajos",
    loadChildren: () =>
      import("./components/legajos/legajos.routes").then(
        (m) => m.legajosRoutes,
      ),
    data: {
      label: "Legajos",
      icon: "contacts",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_legajo-digital",
    loadChildren: () =>
      import("./components/legajo-digital/legajo-digital.routes").then(
        (m) => m.legajoDigitalRoutes,
      ),
    data: {
      label: "Legajo_Digital",
      icon: "inventory_2",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_legajo-digital-clasificadores",
    loadChildren: () =>
      import("./components/clasificadores/clasificadores.routes").then(
        (m) => m.clasificadorRoutes,
      ),
    data: {
      label: "Clasificadores",
      icon: "label",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_onboarding-personas",
    loadChildren: () =>
      import("./components/onboarding/personas/personas.routes").then(
        (m) => m.onboardingPersonasRoutes,
      ),
    data: {
      label: "Onboarding",
      icon: "label",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_onboarding-modelos",
    loadChildren: () =>
      import("./components/onboarding/modelos/modelos.routes").then(
        (m) => m.onboardingModelosRoutes,
      ),
    data: {
      label: "Onboarding",
      icon: "label",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_onboarding-modelos",
    loadChildren: () =>
      import("./components/onboarding/modelos/modelos.routes").then(
        (m) => m.onboardingModelosRoutes,
      ),
    data: {
      label: "Onboarding",
      icon: "label",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_atributos-legajo",
    loadChildren: () =>
      import("./components/atributos-especiales/atributos-legajo/atributos-legajo.routes").then(
        (m) => m.atributosLegajoRoutes,
      ),
    data: {
      label: "Atributos_Especiales",
      icon: "settings",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_atributos-persona",
    loadChildren: () =>
      import("./components/atributos-persona/atributos-persona.routes").then(
        (m) => m.atributosPersonaRoutes,
      ),
    data: {
      label: "Atributos_de_la_Persona",
      icon: "settings",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },

  {
    path: "per_clases-conocimiento",
    loadComponent: () =>
      import("./components/competencias/clases/clases.component").then(
        (m) => m.ClasesCompetenciasComponent,
      ),
    data: {
      label: "Clases de Conocimiento",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_niveles-conocimiento",
    loadComponent: () =>
      import("./components/competencias/niveles/niveles.component").then(
        (m) => m.NivelesComponent,
      ),
    data: {
      label: "Niveles de Conocimiento",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_niveles-conocimiento/niveles-clase",
    loadComponent: () =>
      import("./components/competencias/niveles/niveles-clase/niveles-clase.component").then(
        (m) => m.NivelesClaseComponent,
      ),
    data: {
      label: "Niveles de Conocimiento por Clase",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_conocimientos",
    loadComponent: () =>
      import("./components/competencias/conocimientos/conocimientos.component").then(
        (m) => m.ConocimientosComponent,
      ),
    data: {
      label: "Conocimientos",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_conocimientos-persona",
    loadComponent: () =>
      import("./components/competencias/conocimientos/conocimiento-persona/conocimiento-persona.component").then(
        (m) => m.ConocimientoPersonaComponent,
      ),
    data: {
      label: "Conocimientos por Persona",
      icon: "home",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_incidencias",
    loadComponent: () =>
      import("./components/incidencias/gestion-incidencias/gestion-incidencias.component").then(
        (m) => m.GestionIncidenciasComponent,
      ),
    data: {
      label: "Gestión de Incidencias",
      icon: "report_problem",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_estados-incidencias",
    loadComponent: () =>
      import("./components/incidencias/estados-incidencia/estados-incidencia.component").then(
        (m) => m.EstadosIncidenciaComponent,
      ),
    data: {
      label: "Estados de Incidencias",
      icon: "report_problem",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_tipos-incidencias",
    loadComponent: () =>
      import("./components/incidencias/tipos-incidencia/tipos-incidencia.component").then(
        (m) => m.TiposIncidenciaComponent,
      ),
    data: {
      label: "Tipos de Incidencias",
      icon: "report_problem",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "per_datos-del-personal",
    loadComponent: () =>
      import("./components/reportes/salida-excel/salida-excel.component").then(
        (m) => m.SalidaExcelComponent,
      ),
    data: {
      label: "Salida Excel",
      icon: "description",
      urlexterna: "PER",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
